<!--
 * @Author: Src
 * @Date: 2024-07-16 14:09:28
 * @LastEditTime: 2024-12-28 08:48:50
 * @LastEditors: Src
 * @FilePath: /mobile-station/src/views/boss/Report.vue
 * @Description: 头部注释配置模板
-->
<template>
  <div class="wrap"></div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';
import lazyInject from '@/di';
import BossReportService from '@/services/boss.report.service';
import StorageService from '@/services/storage.service';
import { Toast, Indicator } from 'mint-ui';
import { $delay } from '@/common/utils';

@Component({})
export default class BossReport extends Vue {
  @lazyInject(StorageService)
  protected storage!: StorageService;

  @lazyInject(BossReportService)
  protected bossReportService!: BossReportService;

  public async getBossReport() {
    Indicator.open({
      text: '加载中',
      spinnerType: 'fading-circle',
    });

    try {
      const res = await this.bossReportService.bossReport();
      if (res) {
        window.location.replace(res);
      }
    } catch (error) {
      Toast({
        message: `${error}`,
        iconClass: 'icon icon-error',
      });
    } finally {
      Indicator.close();
    }
  }

  public async created() {
    // eslint-disable-next-line no-console
    console.log('route---', this.$route);
    const token = this.$route.query.tk;
    const data = {
      token,
    };
    this.storage.set('user', data);
    await $delay(500);
    await this.getBossReport();
  }
}
</script>

<style lang="scss" scoped>
.contact-dyh {
  background: #f8f8f8;
  color: #999;
  font-size: 12px;
  text-align: center;
}
</style>
